"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonCircular = exports.ButtonRegular = void 0;
const react_1 = __importDefault(require("react"));
const button_utils_1 = require("../styled/button.utils");
const ButtonStyled_1 = require("../styled/ButtonStyled");
const iconSizeMap = {
    small: 16,
    medium: 20,
    large: 24,
    big: 24,
};
exports.ButtonRegular = react_1.default.forwardRef(({ children, iconLeft, iconRight, ...props }, ref) => {
    const iconProps = {
        color: (0, button_utils_1.getColor)(props, (0, button_utils_1.getIconStyle)(props)),
        size: iconSizeMap[props.size],
    };
    return (react_1.default.createElement(ButtonStyled_1.ButtonRegularStyled, { ...props, ref: ref },
        iconLeft &&
            react_1.default.isValidElement(iconLeft) &&
            react_1.default.cloneElement(iconLeft, iconProps),
        children,
        iconRight &&
            react_1.default.isValidElement(iconRight) &&
            react_1.default.cloneElement(iconRight, iconProps)));
});
exports.ButtonRegular.displayName = 'ButtonRegular';
exports.ButtonCircular = react_1.default.forwardRef(({ children, ...props }, ref) => (react_1.default.createElement(ButtonStyled_1.ButtonCircularStyled, { ...props, ref: ref }, react_1.default.Children.map(children, child => {
    if (react_1.default.isValidElement(child)) {
        const color = (0, button_utils_1.getColor)(props, (0, button_utils_1.getIconStyle)(props));
        const childProps = { color };
        return react_1.default.cloneElement(child, childProps);
    }
    return child;
}))));
exports.ButtonCircular.displayName = 'ButtonCircular';
